import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, onAuthStateChanged } from "../firebase";
import { DirectLine } from "botframework-directlinejs";
import ReactWebChat, { createStore } from "botframework-webchat";
import { URL } from "../urls";
import { chatbotThemeOptions } from "../configs/chatbotTheme";
import Footer from "./Footer";
import Header from "./Header";

const Sltmnit = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [chatConfig, setChatConfig] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user || { displayName: "Guest" });
      setLoading(false);
    });
    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const response = await fetch(URL.GET_TOKEN_SLTMNIT);
        const data = await response.json();
        if (data.token) {
          const directLine = new DirectLine({ token: data.token });
          const store = createStore(
            {},
            ({ dispatch }) =>
              (next) =>
              (action) => {
                if (action.type === "DIRECT_LINE/CONNECT_FULFILLED") {
                  // Welcome message intentionally simplified,
                  // description is shown below the title instead
                }
                return next(action);
              }
          );
          setChatConfig({ directLine, store });
        } else {
          console.error("Error: No token received.");
        }
      } catch (error) {
        console.error("Failed to fetch token:", error);
      }
    };
    fetchToken();
  }, []);

  const handleBackToDashboard = () => {
    navigate("/public-dashboard");
  };

  if (loading) return <div style={{color: "white", textAlign: "center", marginTop: "20%"}}>Loading...</div>;

  return (
    <div className="chatbot-container chat-fit-screen">
      <Header />
      <h1 className="chatbot-title">Aisle Agent for SLTMNIT</h1>
      <p
        style={{
          marginTop: "-6px",
          marginBottom: "14px",
          color: "rgba(255,255,255,0.85)",
          textAlign: "center",
          fontSize: "16px",
          maxWidth: "780px",
          width: "92%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        Learn about courses and programs at SLT-MOBITEL Nebula Institute of Technology.
      </p>
      <div
        style={{
          width: "80%",
          height: "calc(100dvh - 300px)",
          minHeight: "320px",
          borderRadius: "15px",
          border: "1px solid rgba(0, 173, 255, 0.4)",
          boxShadow: "0 0 10px rgba(0, 173, 255, 0.25), 0 6px 18px rgba(0, 0, 0, 0.28)",
          overflow: "hidden",
          margin: "0 auto"
        }}
      >
        {chatConfig ? (
          <ReactWebChat
            directLine={chatConfig.directLine}
            store={chatConfig.store}
            style={{ height: "100%" }}
            styleOptions={chatbotThemeOptions}
          />
        ) : (
          <p style={{color: "white", textAlign: "left"}}>Loading Chatbot...</p>
        )}
      </div>
  

  <button
        className="logout-button"
        onClick={handleBackToDashboard}
        style={{ marginTop: "20px" }}
      >
        Back
      </button>
      <Footer />
    </div>
  );
};

export default Sltmnit;
